module.exports = __webpack_public_path__ + "static/media/menu_icon_05.7d03ec30.png";